<template>
  <div id="playposit__lti-alert-container" class="d-flex">
    <div class="alert-account-action">
      <v-btn
        v-if="accountVerificationAccess"
        @click="invokeAccountVerificationFlow"
        color="primary"
        outline
        depressed
      >
        <v-icon>person</v-icon>
        Not the correct account?
      </v-btn>
    </div>
    <div
      v-show="minimized"
      :class="[
        !edXlmsIconType ? 'minimizer-icon' : 'minimizer-icon-edX',
        'selectable',
        'slideInDown'
      ]"
    >
      <Tooltip left>
        <img
          :src="LMSdata.img"
          @click="activateLTISimpleDash"
          class="pulse"
        />
        <template v-slot:text>
          {{ LTIdata.contentId ? 'Manage Link' : 'Learn More' }}
        </template>
      </Tooltip>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import _ from 'lodash';

import {
  LTI_RENDER_PATHS,
  PLAYPOSIT_PHP_ENDPOINTS,
} from '@Constants';

export default {
  name: 'PlayPositLTI',
  data() {
    return {
      className: 'LTI course',
      dialogData: {},
      minimized: true,
    };
  },
  computed: {
      ...mapGetters([
      'LTIlaunch',
      'LTIdata',
      'LMSdata',
      'LTIclassName',
      'popoverToggles',
      'dialogShow',
      'school',
      'phpApiPrefix',
    ]),
    ...mapGetters('instructors',[
      'classes',
      'queryParamsInstructors',
    ]),
    edXlmsIconType() {
      return this?.LMSdata?.type === 'edX';
    },
    accountVerificationAccess() {
      return this?.school?.permissionKeys?.includes('ltiAccountVerificationFlow');
    },
  },
  methods: {
    ...mapMutations([
      'handleDialogOpen',
      'setGreyscreen',
    ]),
    activateLTISimpleDash: function () {
      let data;
      if (this.LTIdata.contentId) {
        if (
          _.get(this.school, 'config.permissions', []).includes(
            'hasNewGreyscreen',
          ) &&
          this.LTIdata.render_path === LTI_RENDER_PATHS.Play2
        ) {
          this.setGreyscreen({ view: 'lti' });
        } else {
          //if bulb is linked- go to manage screen
          let msg;
          if (this.LTIclassName != '') {
            msg = `"${this.LTIdata.contentName}" assigned to "${this.LTIclassName}"`;
          } else {
            msg = `"${this.LTIdata.contentName}" assigned to `;
          }

          data = {
            title: 'Manage Content Link',
            msg,
            primary: 'Monitor',
            primarylink: 'monitor',
            primaryicon: 'launch',
            secondary: 'Preview',
            secondarylink: 'preview',
            tertiary: 'CSV Download',
            tertiarylink: 'csvDownload',
            exit: 'myBulbs',
            exitText: 'Enter PlayPosit',
          };
        }
      } else {
        // If bulb is not linked, got to reset screen (back to SimpleDash.vue component):
        data = {
          title: 'Set Link',
          msg: 'No content has been attached to this link',
          secondary: 'Learn More',
          secondarylink: 'learnMore',
          primary: 'setLink',
          primarylink: 'exit',
          exit: 'myBulbs',
          exitText: 'Enter PlayPosit',
        };
      }

      this.$store.commit('simpleDashToggle', {
        activate: true,
        type: 'lti',
        data: data,
      });

    },
    invokeAccountVerificationFlow: function () {
      try {
        window.location.replace(PLAYPOSIT_PHP_ENDPOINTS.LTI_13.ltiAccountChange(this.phpApiPrefix));
      } catch (error) {
        console.log({
          error,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
#lti-toolbar {
  height: 70px;
  width: 500px;
  position: absolute;
  top: 0;
  right: 0;
}

#lti-banner {
  display: flex;
  flex-flow: column;
}

.minimizer {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 5px;
}

.minimizer-icon, .minimizer-icon-edX{
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 10px;
  margin-top: 10px;
}

.minimizer-icon img {
  width: 35px;
  height: 35px;
}

.minimizer-icon-edX img {
  width: 61px;
}

@keyframes slideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

.slideInDown {
  animation: slideInDown 0.5s;
}

@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

.pulse {
  animation: pulse 1s infinite;
}
</style>
